import React from 'react';
import { useIntl } from 'react-intl';

import { FormattedDateTimeRange, SquareChip, useSettings, Utils } from 'app/main/components';

export default function WorkReportsDates({ date, from, to }: { date: string; from?: string; to?: string }) {
	const { t } = useSettings();
	const intl = useIntl();

	const formattedDate = intl.formatDate(Utils.parseDate(date)?.toDate(), {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit'
	});

	const formattedTimeRange = <FormattedDateTimeRange from={from} to={to} displayDate={false} displayTime />;

	const label = intl.formatMessage(
		{ id: 'workReport.dates', defaultMessage: from && to ? '{date}, {timeRange}' : '{date}' },
		{ date: formattedDate, timeRange: formattedTimeRange }
	);

	return <SquareChip label={label || t('VIEW_ITEM_NO_DATES')} disabled={!date} />;
}
